import { render, staticRenderFns } from "./SkupDodatniSadrzajDetails.vue?vue&type=template&id=7865f444&scoped=true&"
import script from "./SkupDodatniSadrzajDetails.vue?vue&type=script&lang=js&"
export * from "./SkupDodatniSadrzajDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865f444",
  null
  
)

export default component.exports